import Dialog from '../../Components/Dialog/Dialog'

class DialogContainer {
    element = document.querySelector('#dialog-container') as HTMLDivElement

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    addDialog = (dialog: Dialog) => {
        this.element.appendChild(dialog.element)
    }

    removeDialog = (dialog: Dialog) => {
        this.element.removeChild(dialog.element)
    }
}

export default new DialogContainer()
